import { connect } from 'react-redux';
import { NotFoundComponent } from './not-found.component';

const mapStateToProps = ({ lang }) => ({
  lang: lang.WIDGET,
});

export const NotFound = connect(mapStateToProps)(NotFoundComponent);
